"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderCockpitNotifications = exports.removeCockpitNotificationsTokens = exports.getAPIHost = exports.getAPIClient = exports.debug = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _cockpitNotifications = _interopRequireWildcard(require("@webmotors/cockpit-notifications"));
var _config = require("webmotors-react-pj/config");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const getAPIHost = function () {
  let location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config.CDNConfig;
  const {
    protocol = 'https',
    host = ''
  } = location;
  return "".concat(protocol, "//").concat(host).concat(config.proxyPath);
};
exports.getAPIHost = getAPIHost;
const getAPIClient = function () {
  let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.CDNConfig;
  let globalObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const apiHost = getAPIHost(globalObject.location, config);
  const authToken = (0, _cockpitNotifications.getCockpitCookie)();
  const apiClient = new _cockpitNotifications.APIClient(apiHost, authToken);
  return apiClient;
};
exports.getAPIClient = getAPIClient;
const transformProductsConfig = function () {
  let productsConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const cloneProductsConfig = _objectSpread({}, productsConfig);
  Object.keys(cloneProductsConfig).forEach(productName => {
    const productConfig = cloneProductsConfig[productName];
    productConfig.forEach(config => {
      const {
        regexp
      } = config;
      if (!!regexp && typeof regexp === 'string') {
        const newRegexp = new RegExp(regexp);
        config.regexp = newRegexp;
      }
    });
  });
  return cloneProductsConfig;
};
const removeCockpitNotificationsTokens = function () {
  let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.CDNConfig;
  return new Promise(resolve => {
    const {
      _fbc_
    } = config || {};
    const apiClient = getAPIClient(config);
    (0, _cockpitNotifications.deleteAllTokens)(apiClient, _fbc_).then(() => resolve(true)).catch(() => resolve(false));
  });
};
exports.removeCockpitNotificationsTokens = removeCockpitNotificationsTokens;
const debug = message => {
  if (console && console.debug) console.debug("[Cockpit CDN] ".concat(message));
};
exports.debug = debug;
const renderCockpitNotifications = function () {
  let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.CDNConfig;
  let globalObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const {
    _fbc_ = _config.CDNConfig,
    productsConfig = [],
    currentEnv = process.env.NODE_ENV
  } = config || {};
  const cockpitToken = (0, _cockpitNotifications.getCockpitCookie)();
  const hascockpitToken = !!cockpitToken;
  const windowLocation = globalObject.location;
  const currentLocation = {
    href: windowLocation.href,
    host: windowLocation.hostname
  };
  const apiHost = getAPIHost(windowLocation, config);
  const normalizedProductsConfig = transformProductsConfig(productsConfig);
  const productConfig = (0, _cockpitNotifications.getProductConfigByLocation)(currentLocation, normalizedProductsConfig);
  const {
    identifier: productIdentifier
  } = productConfig || {};
  if (!hascockpitToken) return null;
  return _react.default.createElement(_cockpitNotifications.default, {
    firebaseConfig: _fbc_.firebaseConfig,
    apiHost: apiHost,
    authToken: cockpitToken,
    env: currentEnv,
    bellButtonIcon: "".concat(_config.UrlCockpit, "/assets/img/icons/bell-bold.svg"),
    productIdentifier: productIdentifier
  });
};
exports.renderCockpitNotifications = renderCockpitNotifications;